<mat-card class="m-auto padding12 home-card boxshadowgrey">
    <div>
        <button mat-icon-button color="primary" class="back-button" routerLink="/about">
            <mat-icon>arrow_back</mat-icon>
        </button>
    </div>
    <div>
        <mat-card-title-group class="home-card" id="title">
            <mat-card-title>{{ "LICENCE.HEADER" | translate }}</mat-card-title>
        </mat-card-title-group>

    <p>{{ "LICENCE.EXPLANATION" | translate }}</p>

    <mat-card-content>
        <div class="home-card" id="content" *ngFor="let item of this.licence">
            <mat-expansion-panel hideToggle class="home-nav">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{item[0]}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <p style="white-space: pre-line;">{{item[1]}}</p>
            </mat-expansion-panel>
        </div>
    </mat-card-content>
</div>
</mat-card>

